import styled from "styled-components";
import { useErrors } from "providers/ErrorsProvider";
import { EditorInput } from "components/ui/inputs/EditorInput";
import { Input } from 'components/ui/inputs/Input';
import { SwitchRow } from "components/ui/controls/SwitchRow";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectGeneralInfo = ({
    content, handler,
    projectActivity,
    projectContent,
    projectMap,
    projectNotes,
    projectTasks,
    projectDeliveries,
    projectPhases,
    projectVersions
}) => {
    
    const { setError, unsetError } = useErrors();
    
    return (
        <StyledProjectGeneralInfo>
            <div className="generalInfo">
                <Input
                    title = "Prosjektnummer"
                    value={content.projectNumber}
                    prefix={<MaterialIcon name='confirmation_number' weight={300}/>}
                    onChange={(e) => {handler?.(prev => ({...prev, projectNumber: e.target.value}))}}
                    helptext="Unik identifikasjonsnummer for prosjektet."
                />

                <Input
                    title = "Prosjektmappe"
                    value={content.projectFolder}
                    prefix={<MaterialIcon name='folder' weight={300}/>}
                    onChange={(e) => {handler?.(prev => ({...prev, projectFolder: e.target.value}))}}
                    helptext="Sti til prosjektets mappe for lagring av filer."
                />

                <EditorInput
                    title='Prosjektbeskrivelse'
                    value={content.projectDescription}
                    onChange={(e) => {handler?.(prev => ({...prev, projectDescription: e}))}}
                    helptext="Kortfattet beskrivelse av prosjektet."
                    size="md"
                />
            </div>
            <div className="modules">
                <span>
                    Moduler
                </span>
                <SwitchRow
                    icon={<MaterialIcon name='bar_chart' weight={300}/>}
                    isChecked={projectActivity.enabled}
                    onChange={(e) => {projectActivity.handler(prev => ({...prev, enabled: e.target.checked}))}}
                    title='Prosjektaktivitet'
                    description='Styring av prosjektets aktivitet.'
                />
                <SwitchRow
                    icon={<MaterialIcon name='bookmark' weight={300}/>}
                    isChecked={projectContent.enabled}
                    onChange={(e) => {projectContent.handler(prev => ({...prev, enabled: e.target.checked}))}}
                    title='Innhold'
                    description='Definisjon av prosjektets elementer.'
                />
                <SwitchRow
                    icon={<MaterialIcon name='map' weight={300}/>}
                    isChecked={projectMap.enabled}
                    onChange={(e) => {projectMap.handler(prev => ({...prev, enabled: e.target.checked}))}}
                    title='Kart'
                    description='Geografisk plassering av prosjektet.'
                />
                <SwitchRow
                    icon={<MaterialIcon name='book_5' weight={300}/>}
                    isChecked={projectNotes.enabled}
                    onChange={(e) => {projectNotes.handler(prev => ({...prev, enabled: e.target.checked}))}}
                    title='Notater og dokumenter'
                    description='Bruk av notater tilknyttet til prosjektet.'
                />
                <SwitchRow
                    icon={<MaterialIcon name='ballot' weight={300}/>}
                    isChecked={projectTasks.enabled}
                    onChange={(e) => {projectTasks.handler(prev => ({...prev, enabled: e.target.checked}))}}
                    title='Oppgavebehandling'
                    description='Bruk av kanban og oppfølgning.'
                />
                <SwitchRow
                    icon={<MaterialIcon name='package_2' weight={300}/>}
                    isChecked={projectDeliveries.enabled}
                    onChange={(e) => {projectDeliveries.handler(prev => ({...prev, enabled: e.target.checked}))}}
                    title='Leveranser'
                    description='Kartlegging av leveranser til ulike fag.'
                />
                <SwitchRow
                    icon={<MaterialIcon name='conversion_path' weight={300}/>}
                    isChecked={projectPhases.enabled}
                    onChange={(e) => {projectPhases.handler(prev => ({...prev, enabled: e.target.checked}))}}
                    title='Prosjektfaser'
                    description='Loggføring av prosjektets faser.'
                />
                <SwitchRow
                    icon={<MaterialIcon name='deployed_code' weight={300}/>}
                    isChecked={projectVersions.enabled}
                    onChange={(e) => {
                        if(!projectVersions.isAvailable)
                        {
                            setError("PROJECT_VERSIONS_MISSING_NTM");
                            return;
                        }
                        
                        unsetError("PROJECT_VERSIONS_MISSING_NTM");
                        projectVersions.handler(prev => ({...prev, enabled: e.target.checked}))}
                    }
                    title='Versjonslogg'
                    description='Lagring og forvaltning av lagrede veglinjer.'
                />
            </div>
        </StyledProjectGeneralInfo>
    )
}

const StyledProjectGeneralInfo = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    gap: ${({theme}) => theme.spacing.xl};
    overflow: hidden;

    div.generalInfo
    {
        flex: 1 1 50%;
        display: flex;
        flex-direction: column;
        display: flex;
        gap: ${({theme}) => theme.spacing.lg};
        overflow: auto;
    }

    div.modules
    {
        flex: 1 1 50%;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};
        overflow: auto;

        > span
        {
            font-weight: 500;
        }
    }
`